import { Pipe, PipeTransform } from '@angular/core';
import { IBillingSummaryDTO } from '../../../../shared/models/data/dto/billing/billing-summary.dto';



interface PolicyIssueValidationContext {
  premiumChangeList?: any;
  summary?: IBillingSummaryDTO;
  isOutOfSequenceTransaction: boolean;
  isFromRenewal: boolean;
}

@Pipe({
  name: 'policyIssueValidationMessage'
})
export class GetPolicyIssueValidationMessagePipe implements PipeTransform {
  transform(context: PolicyIssueValidationContext): string {
    const {
      premiumChangeList,
      summary,
      isOutOfSequenceTransaction,
      isFromRenewal
    } = context;

    const finalPremiumFees = premiumChangeList.find(
      item => item.stepAlias === 'FPrePlusFee'
    )?.premiumDiffChange ?? 0;

    const hasNoPayment = (summary?.paid ?? 0) <= 0;
    const isPremiumBearingChange = finalPremiumFees !== 0;

    if (hasNoPayment && isFromRenewal && isPremiumBearingChange && !isOutOfSequenceTransaction) {
      return 'Payment of deposit is required prior to issuance.';
    }

    return '';
  }
}
